import ActionTypes from "../constants/ActionTypes";

const initialState = {
  isFetching: false,
  errorMessage: null,
  data_new: [],
};

const dashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.FETCH_WHAT_NEW_REQUEST:
      return {
        ...state,
        isFetching: true,
        errorMessage: null,
      };
    case ActionTypes.FETCH_WHAT_NEW_SUCCESS:
      return {
        ...state,
        isFetching: false,
        data_new: action.payload.data,
        errorMessage: null
      };
    case ActionTypes.FETCH_WHAT_NEW_FAILURE:
      return {
        ...state,
        isFetching: false,
        errorMessage: action.payload.message,
      };
    default:
      return state;
  }
};

export default dashboardReducer;
